import { NgModule } from "@angular/core";
import { Routes, RouterModule, InitialNavigation, provideRouter, withPreloading } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { QuicklinkStrategy} from 'ngx-quicklink';
export const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
      },
      {
        path: "patient",
        loadChildren:() => import('./patient/patient.module').then(
            (s) => s.PatientModule
          )
      },
      {
        path: "dentist",
        loadChildren: () => import('./dentist/dentist.module').then(
            (s) => s.DentistModule
          )
      },
      {
        path: "marketplace",
        loadChildren:() => import('./agent/agent.module').then(
            (s) => s.AgentModule
          )
      },
      {
        path: "customer",
        loadChildren: () => import('./customer/customer.module').then(
            (s) => s.CustomerModule
          )
      },
      {
        path:'404',
        loadComponent: () => import('./page404/page404.component').then(m => m.Page404Component)
      },
      {
        path: 'sitemap',
        loadComponent: () => import('./sitemap/sitemap.component').then(m => m.SitemapComponent)
      },
      // Redirects
      {
        path: 'dentist/pricing',
        redirectTo: 'pricing',
        pathMatch: 'full'
      },
      {
        path: 'patient-profile/post',
        redirectTo: 'patient/create-post',
        pathMatch: 'full'
      },
      // Patient routes
      {
        path: 'patient-login',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule),
        data: { redirectTo: 'login' }
      },
      {
        path: 'patient-registration',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule),
        data: { redirectTo: 'register' }
      },
      {
        path: 'how-to-videos',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule),
        data: { redirectTo: 'video' }
      },
      {
        path: 'patient-reviews',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule),
        data: { redirectTo: 'patient-reviews' }
      },
      {
        path: 'doctorprofile/:doctorId/:doctorName',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule)
      },
      {
        path: 'mydentist/:doctorId/:doctorName',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule)
      },
      {
        path: 'finance/patient-financing',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule)
      },
      {
        path: 'patient-verification',
        loadChildren: () => import('./patient/patient.module').then(m => m.PatientModule)
      },
      // Dentist routes
      {
        path: 'dentist-signin',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule),
        data: { redirectTo: 'signin' }
      },
      {
        path: 'dentist-signup',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule),
        data: { redirectTo: 'signup2' }
      },
      {
        path: 'list-practice',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule),
        data: { redirectTo: 'list-practice' }
      },
      {
        path: 'best-dental-practice-marketing-online-offer-year',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule)
      },
      {
        path: 'best-dentist-marketing-offer-6months',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule)
      },
      {
        path: 'best-dental-office-marketing-dentists-listings-online-pricing',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule)
      },
      {
        path: 'marketplace/listing',
        loadChildren: () => import('./dentist/dentist.module').then(m => m.DentistModule)
      },
      // Customer routes
      {
        path: 'support/:doctorId/customer-login',
        loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule)
      }
    ]
  },
  {
    path: "**",
    redirectTo: "404"
  }
];

@NgModule({
  imports: [],
  exports: [RouterModule],
  providers: [
    provideRouter(
      routes,
      withPreloading(QuicklinkStrategy)
    )
  ]
})
export class AppRoutingModule {}
